import React, { createContext, useContext, useState, useMemo, useCallback } from "react";
import { translations } from "./i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      return window.localStorage.getItem("rsb_lang") || "id";
    }
    return "id";
  });

  const toggleLang = useCallback(() => {
    setLang((prev) => {
      const next = prev === "id" ? "en" : "id";
      if (typeof window !== "undefined") {
        window.localStorage.setItem("rsb_lang", next);
      }
      return next;
    });
  }, []);

  const value = useMemo(() => {
    const t = translations[lang];
    return { lang, setLang, toggleLang, t };
  }, [lang, toggleLang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
